import React from "react";
import ReactModal from "react-modal";
import * as R from "ramda";
import ReaderFormFields from "./ReaderFormFields";
import { connect } from "react-redux";
import { updateOne } from "actions/reader";
import { fetchAll } from "actions/user";
import Icon from "components/Icon";

const mapStateToProps = state => ({
  isUpdating: state.reader.isUpdating,
  users: state.user.byId,
  isFetching: state.user.isFetching
});

const mapDispatchToProps = { updateOne, fetchAll };

class UpdateReaderModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      reader: { ...props.reader }
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    const { updateOne } = this.props;
    const { reader } = this.state;
    updateOne(reader.id, reader).then(this.handleCloseModal);
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleOpenModal = () => {
    this.props.fetchAll();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id).then(this.handleCloseModal);
  };

  render() {
    const { title, users, isFetching } = this.props;
    const items = Object.keys(users).map(id => users[id]);
    if (!(!isFetching && items)) {
      return null;
    }
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleOpenModal}
        >
          <Icon icon="pencil-alt" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <form onSubmit={this.handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">
                  <ReaderFormFields
                    reader={this.state.reader}
                    onChange={this.handleChange}
                    nodate
                    nocustomer
                    user={items}
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" type="submit">
                    Rediger
                  </button>
                  <button className="btn" onClick={this.handleCloseModal}>
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ReactModal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateReaderModal);



// WEBPACK FOOTER //
// ./src/components/UpdateReaderModal.js